import { supabase } from '@/lib/supabase'
import type { TF } from '../types'

export type PivotMarker = {
  time: number // seconds (UTC)
  type: 'pivot_high_close' | 'pivot_low_close'
  classification?: 'HH' | 'HL' | 'LH' | 'LL'
  value?: number
  label?: string
}

export async function fetchPivotMarkers(symbol: string, timeframe: TF, limit = 300): Promise<PivotMarker[]> {
  const { data, error } = await supabase
    .from('market_pivots')
    .select('pivot_time,pivot_type,classification,pivot_close,pivot_label')
    .eq('symbol', symbol)
    .eq('timeframe', timeframe)
    .order('pivot_time', { ascending: true })
    .limit(limit)
  if (error) throw error
  return (data || []).map((r: any) => ({
    time: Math.floor(new Date(r.pivot_time).getTime() / 1000),
    type: r.pivot_type,
    classification: r.classification,
    value: r.pivot_close != null ? Number(r.pivot_close) : undefined,
    label: r.pivot_label || undefined,
  }))
}
